import { MultiEditWidgetConfig } from '../Widget.types';
import { DEFAULT_BORDER_WIDTH } from './BasicShapeWidget.config';
import { BasicShapeWidgetData } from './BasicShapeWidget.types';

/**
 * The multi edit config for the basic shape widget
 * For reading/updating the basic shape widget data when there are multiple widgets selected
 */
const multiEditConfig: MultiEditWidgetConfig<BasicShapeWidgetData> = {
  color: {
    onChange: ({ value: newFillColor, widgetData }) => {
      const newWidgetData: Partial<BasicShapeWidgetData> = { fillColor: [newFillColor] };
      const fillColor = widgetData.fillColor;
      if (fillColor[1]) newWidgetData.fillColor!.push(fillColor[1]);

      return newWidgetData;
    },
    getValue: (widgetData) => widgetData?.fillColor?.[0],
  },
  borderColor: {
    onChange: ({ value: color, widgetData }) => {
      const newBorder = { color, ...(widgetData.border.width === 0 && { width: DEFAULT_BORDER_WIDTH }) };
      const newWidgetData = { border: newBorder };

      return newWidgetData;
    },
    key: 'border.color',
  },
  borderStyle: {
    onChange: ({ value: newBorderStyle }) => {
      const widgetData = { border: { style: newBorderStyle } };
      return widgetData;
    },
    key: 'border.style',
  },
  borderWidth: {
    onChange: ({ value: newBorderWidth }) => {
      const widgetData = { border: { width: newBorderWidth } };
      return widgetData;
    },
    key: 'border.width',
  },
  type: {
    onChange: ({ value: updatedWidgetData }) => {
      const widgetData = updatedWidgetData;
      return widgetData;
    },
    key: 'type',
    getValue: (widgetData) => widgetData.type,
  },
  dimension: {
    onChange: ({ value: updatedWidgetData }) => {
      const { widthPx, heightPx, rotateDeg, mirror, isAspectRatioLocked } = updatedWidgetData;
      return { widthPx, heightPx, rotateDeg, mirror, isAspectRatioLocked };
    },
    key: 'dimensions',
  },
};

export { multiEditConfig };
